import { DATE_PIPE_DEFAULT_TIMEZONE } from '@angular/common';
import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroDanosLista {
    lastSetDefault: Date;

    DZ03DATA_DE: Date | undefined;
    DZ03DATA_ATE: Date | undefined;
    CZ03LOTE: string;
}

export class FiltroDanos {
    dados: IFiltroDanosLista;
    storageName: string;

    constructor(private poStorageService: PoStorageService) {

        this.dados = this.setDefault();
        this.storageName = 'interface-filtro-danos-lista'

        this.poStorageService.get(this.storageName).then((filtro: IFiltroDanosLista) => {
            if (filtro) {

                const {
                    lastSetDefault,
                    DZ03DATA_DE,
                    DZ03DATA_ATE
                } = filtro;

                if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
                    this.dados = this.setDefault();
                } else {
                    this.dados = {
                        ...filtro,
                        lastSetDefault: new Date(lastSetDefault),
                        DZ03DATA_DE: DZ03DATA_DE ? new Date(DZ03DATA_DE) : undefined,
                        DZ03DATA_ATE: DZ03DATA_ATE ? new Date(DZ03DATA_ATE) : undefined,
                    };
                }
            }
        });

    }


    public setDefault = (): IFiltroDanosLista => {
        return {
            lastSetDefault: new Date(),
            DZ03DATA_DE: this.getData(-7),
            DZ03DATA_ATE: new Date(),
            CZ03LOTE: '',
        };
    }

    public setStorage = (): void => {
        this.poStorageService.set(this.storageName, this.dados);
    }

    private getData = (dias: number): Date => {
        const dataDe = new Date();
        dataDe.setDate(dataDe.getDate() + dias);
        return dataDe;
    }


}